module.exports = __webpack_public_path__ + "static/media/logo-presidentemedici.2f4687f7.png";